import { Tooltip, Whisper } from 'rsuite';
import { ContentFamilyModal } from '../../../pages/IPA/RevisaoPrecos/Components/GetFamilyListModal/types';
import { BaseCell } from '../BaseCell';
import { BaseCellProps } from '../BaseCell/BaseCell';
import styles from './FatorCell.module.scss';

type FatorCellProps = BaseCellProps & {
  rowData: ContentFamilyModal;
};

const roundToTwoDecimalPlaces = (value: number) => Math.round((value + Number.EPSILON) * 100) / 100;

export const formatFactorValue = (factor: number) => {
  return roundToTwoDecimalPlaces(factor).toFixed(2).replace('.', ',');
};

export const formatFactorBase = (factor: number) => {
  const roundedFactor = roundToTwoDecimalPlaces(factor);

  if (roundedFactor === 1) return 'IGUAL';

  const variation = roundToTwoDecimalPlaces((roundedFactor - 1) * 100)
    .toFixed(2)
    .replace('.', ',');

  return `${roundedFactor > 1 ? '+' : ''}${variation}%`;
};

const FatorCell = ({ rowData, ...props }: FatorCellProps) => {
  const { factor } = rowData;
  const formattedFactor = factor ? formatFactorValue(factor) : null;
  const factorBase = factor ? formatFactorBase(factor) : null;

  return (
    <BaseCell {...props}>
      {factor ? (
        <Whisper delayShow={0.2} trigger="hover" placement="right" speaker={<Tooltip>{formattedFactor}</Tooltip>}>
          <>
            <span className="font-size-100-semibold">{formattedFactor}</span>
            <span className={styles['factor-base']}>{factorBase}</span>
          </>
        </Whisper>
      ) : null}
    </BaseCell>
  );
};

export default FatorCell;
